/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The cells parameters for Expenses Analyzer
 *
 * @author Maxim Fedorov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.1.1
 * @since 1.1.0
 */

import { EColumnCell, EColumnFilter } from '../../../../../components/Table/types/columnTypes';
import { EExpensesAnalyzerField } from '../types/expensesAnalyzerTableTypes';

export const ExpensesAnalyzerCellConfig = {
    [EExpensesAnalyzerField.ACCOUNT]: 150,
    [EExpensesAnalyzerField.ACCOUNT_REGION]: 160,
    [EExpensesAnalyzerField.MONTH_CHARGE_RTPL]: 160,
    [EExpensesAnalyzerField.AMOUNT_TOTAL]: 140,
    [EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO]: 140,
    [EExpensesAnalyzerField.AMOUNT_LOCAL]: 140,
    [EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING]: 140,
    [EExpensesAnalyzerField.AMOUNT_ROAMING]: 140,
    [EExpensesAnalyzerField.BIS_ACCOUNT_ID]: 160,
    [EExpensesAnalyzerField.CHARGES]: 160,
    [EExpensesAnalyzerField.MONTH_CHARGE_SRLS]: 160,
    [EExpensesAnalyzerField.MONTH_RANGE]: 160,
    [EExpensesAnalyzerField.MSISDN]: 160,
    [EExpensesAnalyzerField.NAME]: 240,
    [EExpensesAnalyzerField.DETAILS]: 160,
};

export const analyzerColumnFilterType = (name: string): string => {
    switch (name) {
        case EExpensesAnalyzerField.MSISDN:
        case EExpensesAnalyzerField.NAME:
        case EExpensesAnalyzerField.ACCOUNT:
            return EColumnFilter.filterSearch;
        case EExpensesAnalyzerField.CHARGES:
        case EExpensesAnalyzerField.MONTH_CHARGE_SRLS:
        case EExpensesAnalyzerField.MONTH_CHARGE_RTPL:
        case EExpensesAnalyzerField.AMOUNT_TOTAL:
        case EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO:
        case EExpensesAnalyzerField.AMOUNT_LOCAL:
        case EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING:
        case EExpensesAnalyzerField.AMOUNT_ROAMING:
            return EColumnFilter.filterRange;
        default:
            return '';
    }
};

export const getExpensesAnalyzerColumnCellType = (name: EExpensesAnalyzerField): string => {
    switch (name) {
        case EExpensesAnalyzerField.ACCOUNT:
            return EColumnCell.linkAccountExpenses;
        case EExpensesAnalyzerField.MSISDN:
            return EColumnCell.linkMobile;
        case EExpensesAnalyzerField.NAME:
            return EColumnCell.text;
        case EExpensesAnalyzerField.CHARGES:
        case EExpensesAnalyzerField.MONTH_CHARGE_SRLS:
        case EExpensesAnalyzerField.MONTH_CHARGE_RTPL:
        case EExpensesAnalyzerField.AMOUNT_TOTAL:
        case EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO:
        case EExpensesAnalyzerField.AMOUNT_LOCAL:
        case EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING:
        case EExpensesAnalyzerField.AMOUNT_ROAMING:
            return EColumnCell.amount;
        default:
            return EColumnCell.text;
    }
};

export const getExpensesAnalyzerColumnFixedType = (name: EExpensesAnalyzerField): string | boolean =>
    name === EExpensesAnalyzerField.ACCOUNT || name === EExpensesAnalyzerField.MSISDN
    ? 'left' : false;
